<template>
  <el-form :model="value" :rules="rules" ref="ruleForm" label-width="80px">
    <el-row :gutter="20">
      <el-col :span="8" v-for="(item, index) in pictureList" :key="index">
        <el-form-item :label="item.label" :prop="item.key">
          <el-upload
            class="avatar-uploader"
            name=""
            :http-request="httpRequest"
            action=""
            :before-upload="beforeEBookPictureUpload"
            :on-success="(response) => handleEBookPictureSuccess(response, item.key)"
            :show-file-list="false"
            :with-credentials="false"
          >
            <img v-if="value[item.key] && value[item.key].file_url"
                 v-lazy="value[item.key].file_url" :key="value[item.key].file_url"
                 class="cover">
            <i v-if="value[item.key] && value[item.key].file_url" class="el-icon-delete" @click.stop="handleRemove(item.key)"></i>
            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
          </el-upload>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import httpRequest from 'src/common/httpRequest';
  import {
    get,
    extend
  } from 'lodash'

  export default {
    props: {
      pictureList: {
        type: Array,
        default() {
          return [
            {
              label: '二维码',
              key: '0'
            },
            {
              label: '条形码',
              key: '1'
            },
            {
              label: '证书',
              key: '2'
            }
          ];
        }
      },
      value: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        httpRequest,
        rules: {},
        formData: {}
      }
    },
    methods: {
      beforeEBookPictureUpload(file) {
        let isJPG = (file.type).indexOf("image/") !== -1;
        if (!isJPG) {
          this.$message.error('只能上传图片格式文件');
          return false;
        }
        return true;
      },
      handleEBookPictureSuccess(data, key) {
        const result = extend({}, this.value, {
          [key]: {
            upload_resource_id: get(data, 'list[0].id'),
            file_url: get(data, 'list[0].file_url')
          }
        });
        this.$emit('change', result);
        this.$emit('input', result);
      },
      handleRemove(key) {
        const result = extend({}, this.value, {
          [key]: {
            upload_resource_id: null,
            file_url: ''
          }
        });
        this.$emit('change', result);
        this.$emit('input', result);
      },
    },
    created() {

    }
  }
</script>

<style scoped>
  .cover {
    width: 178px;
    height: 178px;
    display: block;
  }
  >>>.avatar-uploader-icon{
    line-height: 178px;
  }
</style>
